module.exports = __webpack_public_path__ + "img/door-closed-icon.6bfb4dc9.svg";